module.exports = __webpack_public_path__ + "media/images/document-icon-b387682d7ee3b747564fdab80d6641ea.png";